import type { NudgeContent } from '../../hooks/useConversation';

interface ChatNudgeBannerProps {
  nudge: NudgeContent;
  onDismiss: () => void;
}

export default function ChatNudgeBanner({ nudge, onDismiss }: ChatNudgeBannerProps) {
  return (
    <div className="chat-nudge-banner">
      <span className="chat-nudge-icon">{nudge.icon}</span>
      <span className="chat-nudge-text">
        {nudge.completion !== undefined && (
          <span className="chat-nudge-pct">{nudge.completion}%</span>
        )}
        {nudge.text}
      </span>
      <button
        type="button"
        className="chat-nudge-close"
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
}
